import { render, staticRenderFns } from "./smsnotify.vue?vue&type=template&id=053ddad9"
import script from "./smsnotify.vue?vue&type=script&lang=js"
export * from "./smsnotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports